export enum ResourceState {
    WIP = 'WdgHub.Wip',
    DRAFT = 'WdgHub.Draft',
    REVIEW = 'WdgHub.Review',
    APPROVED_HIDE = 'WdgHub.ApprovedHide',
    APPROVED_VISIBLE = 'WdgHub.ApprovedVisible',
    APPROVED_PUBLISHED = 'WdgHub.ApprovedPublished'
}
